<template>
	<div id="app">
		<v-app id="inspire">
			<v-toolbar dark color="blue-grey darken-4" fixed>
				<v-toolbar-side-icon  @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
                <v-toolbar-title class="white--text">
                    <img onclick="window.location.href = window.location.origin+'/branch-locator';" width="300" height="100" class="pt-1" style="vertical-align:middle" :src="require('../assets/TCM-LOGO-WHITE.png')"/>
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn dark flat class="hidden-sm-and-down" @click="logInValidation()"><v-icon small>location_on</v-icon>Locate A Branch</v-btn>
			</v-toolbar>

			<v-navigation-drawer :clipped="true" app hide-overlay class="hidden-md-and-up" v-model="drawer" temporary id="drawer">

                <v-list flat dark color="blue-grey darken-4">
					<v-list-tile @click="(goToPage('branch-locator'))">
						<v-list-tile-action><v-icon>location_on</v-icon></v-list-tile-action>
						<v-list-tile-content>
						<v-list-tile-title>Locate a Branch</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>

					<v-divider></v-divider>

					<v-list-tile v-if="user" class="mt-3" @click="(goToPage('logout'),drawer=false)">
						<v-list-tile-action>
						<v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
						<v-list-tile-title class="grey--text text--darken-1">Log-out</v-list-tile-title>
					</v-list-tile>
					
					<v-list-tile v-else class="mt-3" @click="(goToPage('login'),drawer=false)">
						<v-list-tile-action>
						<v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
						<v-list-tile-title class="grey--text text--darken-1">Log-in</v-list-tile-title>
					</v-list-tile>
                </v-list>
            </v-navigation-drawer>
				
            <v-content>
                <v-container fill-height>
                    <v-layout>
                        <v-flex>
                            <router-view/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-content>

			<v-dialog v-model="dialog" persistent width="300">
				<v-card color="blue-grey darken-4" light>
					<v-card-text class="body-2 font-weight-medium white--text"> {{dialogLabel}}
						<v-layout row justify-center>
						<v-progress-linear :indeterminate="true"
							:size="70"
							:width="5"
							color="white"
						></v-progress-linear>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-snackbar v-model="showdialog" bottom right :color="dialogColor" :timeout=3000>
				{{dialogMsg}}
				<v-btn dark small flat @click="showdialog = false">Close</v-btn>
			</v-snackbar>

			<v-container grid-list-md text-xs-center>
				<v-layout>
					<v-flex xs12 class="headline font-weight-regular">
					Sign-in to continue
					</v-flex>
				</v-layout>

				<v-layout row justify-center >
					<v-card class="mx-auto">
						<v-container>
							<v-layout row wrap>
								<v-flex xs12>
									<div id="firebaseui-auth-container"></div>
									<div v-show="show2FA">
										<v-layout row wrap>
											<v-flex sm4 md4></v-flex>
											<v-flex xs12 sm4 md4>
												<v-text-field v-on:keyup.enter="submit(),dialogLabel='Logging in...',dialog=true" outline v-model="code" maxlength="6" type="text" required placeholder="Enter code sent" ></v-text-field>
											</v-flex>
											<v-flex sm4 md4></v-flex>
										</v-layout>
										<v-btn dark color="blue accent-4" @click="submit(),dialogLabel='Logging in...',dialog=true">Submit</v-btn>
										<v-btn dark color="red accent-4" :disabled="disableBtn" @click="resendCode(),dialogLabel='Resending....',dialog=true">Re-send</v-btn>
										<p>A verification code was sent to your SMS</p>
									</div>
								</v-flex>
							</v-layout>

							<v-divider></v-divider>
							<v-layout row wrap>
								<v-flex xs12>
									<p class="text-justify" style="font-size: 10px;">If you login to Service Scheduler using credentials of a third party Social Networking Site (SNS) such as Facebook, Google, you authorize us to collect your authentication information, such as your name, e-mail address and encrypted access credentials. We may store this information so that it can be used for the purposes explained in this statement , and it may also be used to verify your credentials with the SNS. The information available to Transcycle Marketplace from an SNS is affected by the privacy settings you establish at the SNS. You understand and agree that an SNS use of information they collect from you is governed by their privacy policies, and Transcycle Marketplace's use of such information is governed by this statement.</p>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card>
				</v-layout>
			</v-container>
		</v-app>
	</div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import { mapGetters, mapActions, mapState } from "vuex"
import router from '../router'
import { db } from '../main.js'
import moment from 'moment'
import profileComponent from './Profile.vue'

export default {
	components: {
        profileComponent,
    },
	data: () => ({
		drawer : null,
		ui: null,
		code: null,
		codeHolder: null,
		show2FA: false,
		codeResult: "",
		disableBtn: null,
		dialog: false,
		dialogLabel: "",
		showdialog: false,
		dialogMsg: "",
		dialogColor: "",
	}),
	mounted() {
		let self = this
		if (self.user) {
			firebase.auth().signOut().then(function() {
				self.$store.dispatch('setAuth', false) 
			}).catch(function(error) {console.log(error)})
		}

		let signInSuccessUrl = localStorage.getItem("redirect")
		if (signInSuccessUrl != null ) {
			signInSuccessUrl = localStorage.getItem("redirect")
		} else {
			signInSuccessUrl = "/branch-locator"
		}

		let uiConfig = {
			signInSuccessUrl: signInSuccessUrl,
			signInOptions: [
				firebase.auth.EmailAuthProvider.PROVIDER_ID,
				firebase.auth.GoogleAuthProvider.PROVIDER_ID,
				firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            ],
			
			callbacks: {
				signInSuccessWithAuthResult: function(authResult, redirectUrl) {
					firebase.auth().onAuthStateChanged(function(user) {
						if (user) {
							let googleUser = {
								uid: user.uid,
								email: user.email,
								displayName: user.displayName,
								photoURL: user.photoURL,
							}
							self.$store.dispatch("setUser", googleUser).then(() => {
								user.getIdToken().then(function(accessToken) {
									self.$store.dispatch("setToken", accessToken).then(() => {
										self.$store.dispatch("setAuth", true).then(() => {
											if(self.user.mobileNumber) {
												self.send2faCode()
												self.show2FA = true
											} else {
												setTimeout(() => {
													db.collection("Users"+self.$stage).doc(user.uid)
													.onSnapshot(function(doc) {
														self.$store.dispatch("setRole", doc.data().role).then(() => {
															window.location.href = signInSuccessUrl
															console.log("go to registration")
															self.$store.dispatch("setProfile", "1")
														}).catch(error => console.log(error))
													})
												}, 1000)
											}
										}).catch(error => console.log(error))	
									})
								})
							})
						} 
					}, function(error) {
						console.log(error)
					})
					return false
				}
			}
		}
		self.ui = new firebaseui.auth.AuthUI(firebase.auth())
		self.ui.start("#firebaseui-auth-container", uiConfig)
	},

	methods: {
        goToPage(page) {
            this.$router.push("/"+page)
		},

		async submit() {
			let self = this
			let signInSuccessUrl = localStorage.getItem("redirect")
			if (signInSuccessUrl != null ) {
				signInSuccessUrl = localStorage.getItem("redirect")
			} else {
				signInSuccessUrl = "/branch-locator"
			}
			await self.verify2FACode(self.code)
		},

		// ********* SEND SMS CODE *************
		send2faCode() {
			let self = this
			let body = {
				user: self.user.email,
				mobile: 63+ self.user.mobileNumber
			}

			self.$axios.post(self.$twoFACode, body).then(response => {
				self.codeHolder = response.data.code
			}).then(function(){
				console.log("OTP Code was sent successfully!")
			})
		},

		// ********* VERIFY SMS CODE *************
		verify2FACode(code) {
			let self = this
			let body = {
				user: self.user.email,
				code: code
			}

			self.$axios.post(self.$verifyCode, body).then(response => { 
				self.codeResult = response.data.coderesult
				let signInSuccessUrl = localStorage.getItem("redirect")

				if (signInSuccessUrl != null ) {
					signInSuccessUrl = localStorage.getItem("redirect")
				} else {
					signInSuccessUrl = "/branch-locator"
				}

				if(self.codeResult == "valid code") {
					firebase.auth().onAuthStateChanged(function(user) {
						db.collection("Users"+self.$stage).doc(user.uid)
						.onSnapshot(function(doc) {
							self.$store.dispatch("setRole", doc.data().role).then(() => {
								window.location.href = signInSuccessUrl
								self.dialog=false
							}).catch(error => console.log(error))
						})
					})

				} else {
					self.dialogMsg = self.codeResult
					self.dialogColor = "error"
					self.showdialog = true
					self.dialog=false
				}
			})
		},

		// ********* RESEND SMS CODE *************
		resendCode() {
			let self = this
			let message = self.codeHolder + " is your verification code."
			
			self.$axios.defaults.headers.common['Authorization']= self.$smsAuthorization
			self.$axios.defaults.headers.common['Content-Type']= self.$contentType
	
			let body = {
				"source": "UNISTAR",
				"destination": 63+ self.user.mobileNumber,
				"text": message,
				"subaccount": self.$subAccount
			}

			self.$axios.post(self.$smsUrl,body).then(response => { 
				self.disableBtn="disabled"
				self.dialog=false
			})
		},

		logInValidation() {
			let self = this
			firebase.auth().onAuthStateChanged(function(user) {
				if(self.show2FA == true && (user.uid != null || user.uid != "")){
					self.dialogMsg = "Please enter verification code"
					self.dialogColor = "error"
					self.showdialog = true
				} else {
					self.goToPage("branch-locator")
				}
			})
		},
	},
	
	computed: {
		...mapGetters(["auth","user"])
	},

	beforeDestroy() {
		this.ui.delete()
	}
}
</script>

<style scoped>
	* {
		text-align: center;
	}

	#drawer{
		background: rgb(12, 12, 12);
	}

</style>

